import { List } from "immutable";

import { ContentType } from "@seneca/course-service-types";

import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";
import {
  getMany as getContents,
  getExisting as getExistingContents,
  listMany as listContents,
  listExisting as listExistingContents
} from "seneca-common/utils/selectors/map-query";

import {
  ContentId,
  SectionId
} from "../../../models/state/contents/content/Content";
import ContentOptions from "../../../models/state/contents/content/options/ContentOptions";
import { Contents } from "../../../models/state/contents/Contents";
import { ModuleId } from "../../../models/state/modules/module/ContentModule";
import * as contentSelectors from "./content";

export function getContent(contents: Contents, contentId: ContentId) {
  return contents.get(contentId);
}

export { getExistingContents, getContents, listExistingContents, listContents };

// @ts-ignore
export const getContentId: (
  contents: Contents,
  contentId: ContentId
  // @ts-ignore
) => ContentId = composeSelector(getContent, contentSelectors.getId);

export const getContentParentId: (
  contents: Contents,
  contentId: ContentId
) => SectionId | undefined = composeSelector(
  getContent as any,
  contentSelectors.getParentId
);

export const getContentModuleIds: (
  contents: Contents,
  contentId: ContentId
) => List<ContentId> = composeSelector(
  // @ts-ignore
  getContent,
  contentSelectors.getContentModuleIds
);

export const getContentOptions: (
  contents: Contents,
  contentId: ContentId
  // @ts-ignore
) => ContentOptions = composeSelector(getContent, contentSelectors.getOptions);

export const getContentType: (
  contents: Contents,
  contentId: ContentId
) => ContentType | undefined = composeSelector(
  // @ts-ignore
  getContent,
  contentSelectors.getContentType
);

export const contentIsSequential: (
  contents: Contents,
  contentId: ContentId
) => boolean =
  // @ts-ignore
  composeSelector(getContent, contentSelectors.isSequential);

export const contentIsExercise: (
  contents: Contents,
  contentId: ContentId
) => boolean =
  // @ts-ignore
  composeSelector(getContent, contentSelectors.isExercise);

export const contentModuleIdIsLastInContent: (
  contents: Contents,
  contentId: ContentId,
  moduleId: ModuleId
) => boolean = composeSelector(
  // @ts-ignore
  getContent,
  contentSelectors.contentModuleIdIsLastInContent,
  dropContentId
);

export const getContentModuleIndex: (
  contents: Contents,
  contentId: ContentId,
  moduleId: ModuleId
) => number = composeSelector(
  // @ts-ignore
  getContent,
  contentSelectors.getContentModuleIndex,
  dropContentId
);

// @ts-ignore
export const getContentModuleIdAtIndex: (
  contents: Contents,
  contentId: ContentId,
  moduleId: number
) => ModuleId = composeSelector(
  // @ts-ignore
  getContent,
  contentSelectors.getContentModuleIdAtIndex,
  dropContentId
);

export const getFirstContentModuleId: (
  contents: Contents,
  contentId: ContentId
) => ModuleId = composeSelector(
  // @ts-ignore
  getContent,
  contentSelectors.getFirstContentModuleId
);

// @ts-ignore
export const getFollowingContentModuleId: (
  contents: Contents,
  contentId: ContentId,
  moduleId: ModuleId
) => ModuleId = composeSelector(
  // @ts-ignore
  getContent,
  contentSelectors.getFollowingContentModuleId,
  dropContentId
);

export const includesContentModuleId: (
  contents: Contents,
  contentId: ContentId,
  moduleId: ModuleId
) => boolean = composeSelector(
  // @ts-ignore
  getContent,
  contentSelectors.includesContentModuleId,
  dropContentId
);

function dropContentId(content: ContentId, moduleId: ModuleId) {
  return [moduleId];
}
